import { useEffect, useState } from 'react'

import { Button } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton'
import { Delete } from '@material-ui/icons'
import AddIcon from '@material-ui/icons/Add'
import SetState from 'Components/Hooks/SetState'
import BasicTable from 'Components/UI/Atoms/BasicTable'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import ContentWithOutSubTabs from 'Components/UI/Molecules/ContentWithOutSubTabs'
import InputsWithoutValidate from 'Components/UI/Molecules/InputsWithoutValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import useStyles from 'Components/UI/Organisms/Vehicles/Quotations/Edit/Fields/Home/styles'
import { interfaces } from 'service/interfaces'

import AddItem from '../../../Orders/Update/Recibo/Add'
import { editFields } from '../../../Orders/Update/Recibo/Add/Fields'

import { DataExtra } from './Fields'

const PaymentMethods = ({
  data,
  onDataChange,
  edit,
  setRender,
  render,
  dataBefore,
  setData,
  empresaId,
}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [formEdit, setFormEdit] = useState(data.receiptDetails)
  const [selectedRow, setSelectedRow] = useState(null)
  const createDismissableSnackbar = useCustomSnackbar()

  const {
    state: paymentDetail,
    setOpen: setOpenPaymentDetail,
    setClose: setClosePaymentDetail,
  } = SetState()

  const { state: add, setOpen: openAdd, setClose: closeAdd } = SetState()
  const [tab, setTab] = useState(0)

  const classes = useStyles()

  async function orderInfo(id) {
    await interfaces.salesReceipt.infoOneReceipt(id, empresaId).then((res) => {
      setData((prevData) => ({
        ...prevData,
        receipt: res.data.receipt,
        receiptDetails: res.data.receiptDetails,
      }))
      setFormEdit(res.data.receiptDetails)
    })
  }

  useEffect(() => {
    const id = data.receipt.id
    orderInfo(id)
    // eslint-disable-next-line
  }, [formEdit.length, data.receipt.id])

  async function deleteDetail(id) {
    setIsLoading(true)
    const recibo = data.receipt.id
    await interfaces.salesReceipt.deleteReceiptItem(id, empresaId, recibo).then((res) => {
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
      deleteItem(id)
    })
    setIsLoading(false)
  }

  const deleteItem = (id) => {
    let newItem = formEdit.filter((e) => e.id !== id)

    const deletedItem = formEdit.find((e) => e.id === id)
    const deletedImporte = deletedItem ? Number(deletedItem.importe) : 0

    setFormEdit(newItem)
    onDataChange(newItem) // creoq ue no hace falta porque se actualiza al eliminar
    setData((prevData) => ({
      ...prevData,
      receiptDetails: prevData.receiptDetails.filter((detail) => detail.id !== id),
      receipt: {
        ...prevData.receipt,
        total: Math.trunc(prevData.receipt.total || 0) - Math.trunc(deletedImporte),
        // saldoResto: Math.trunc(prevData.receipt.saldoResto || 0) + Math.trunc(deletedImporte),
      },
    }))
  }

  const iconDelete = (id, importe) => (
    <IconButton
      onClick={(event) => {
        event.stopPropagation()
        deleteDetail(id, importe)
      }}
      disabled={data.comprobantes?.length > 0 ? true : !edit}
      style={{ padding: '0px' }}
    >
      <Delete />
    </IconButton>
  )

  const getMetodoPagoNombre = (id) => {
    const metodo = dataBefore?.data?.metodosPago?.find((metodo) => metodo.id === id)
    return metodo?.tipo
  }

  const onClickRow = (index) => {
    if (!edit) return

    const selectedItem = formEdit.find((obj) => obj.id === index.id)

    setSelectedRow(selectedItem)
    setOpenPaymentDetail(true)
  }

  const editItem = async () => {
    if (!selectedRow.importe) {
      createDismissableSnackbar("El campo 'Importe' es obligatorio", {
        variant: 'error',
      })
      return
    }
    setIsLoading(true)
    const values = {
      id: selectedRow.id,
      empresa: empresaId,
      importe: Number(selectedRow.importe.replace(/[^0-9.,]+/g, '')),
      detalle: selectedRow.detalle,
      recibo: data.receipt.id,
      barcode: selectedRow.barcode,
      cupon: selectedRow.cupon,
      lote: selectedRow.lote,
      origen: selectedRow.origen,
      moneda: selectedRow.moneda,
    }
    await interfaces.salesReceipt.editReceiptItem(values).then((res) => {
      const previousRow = formEdit.find((row) => row.id === selectedRow.id)
      const previousImporte = previousRow ? Number(previousRow.importe) : 0
      const importeDifference = values.importe - previousImporte
      const updatedRows = formEdit.map((row) =>
        row.id === selectedRow.id ? { ...row, importe: values.importe } : row
      )
      orderInfo(data.receipt.id)
      setFormEdit(updatedRows)
      setData((prevData) => ({
        ...prevData,
        receiptDetails: updatedRows,
        receipt: {
          ...prevData.receipt,
          total: Math.trunc(prevData.receipt.total || 0) + Math.trunc(importeDifference),
          // saldoResto: Math.trunc(prevData.receipt.saldoResto || 0) - Math.trunc(importeDifference),
        },
      }))
      createDismissableSnackbar(res.data, {
        variant: 'success',
      })
    })
    setClosePaymentDetail()
    setIsLoading(false)
    // closeCancel()
  }

  const handleChangeItem = (name, value) => {
    setSelectedRow((prevInfo) => ({
      ...prevInfo,
      [name]: value,
    }))
  }

  const renderTabs = (index) => {
    switch (index) {
      case 0:
        return (
          <>
            <div style={{ margin: '3rem' }}>
              <InputsWithoutValidate
                fields={DataExtra(data.receipt)}
                spacing={1}
                justifyContent="flex-end"
                key={data.receipt ? data.receipt.id : 'empty'}
              />
            </div>
            <div
              style={{
                display: 'flex',
                margin: '2rem',
                cursor: edit ? 'pointer' : '',
                overflow: 'scroll',
              }}
            >
              <BasicTable
                col={[
                  { title: 'Medio de pago', style: { width: '80px' } },
                  { title: 'Descripción', style: { width: '100px' } },
                  { title: 'Importe en pesos', style: { width: '80px' } },
                  { title: '', style: { width: '40px' } },
                  { title: '', style: { display: 'none' } },
                ]}
                size="small"
                rows={formEdit?.map((row) => {
                  return {
                    tipo: getMetodoPagoNombre(row.tipo),
                    descripcion: row.descripcion,
                    importe: `$${row.importe}`,
                    action: iconDelete(row.id, row.importe),
                    id: row.id,
                  }
                })}
                onClickRow={onClickRow}
              />
              <div className={classes.buttons}>
                <Button
                  onClick={openAdd}
                  disabled={data.comprobantes?.length > 0 ? true : data.receipt.id ? !edit : true}
                  color="primary"
                  variant="contained"
                  size="large"
                  style={{
                    height: '40px',
                    marginRight: '1rem',
                    marginLeft: '.5rem',
                  }}
                >
                  <AddIcon />
                </Button>
              </div>
            </div>
          </>
        )
      default:
        break
    }
  }

  const isSubmitDisabled = selectedRow
    ? Number(selectedRow.importe) <= 0 ||
      (selectedRow.tipo === 5
        ? !(
            selectedRow.verificacion &&
            [1, 2, 3, 4, 5, 6, 7, 8, 9].includes(Number(selectedRow.verificacion3))
          )
        : selectedRow.tipo === 1 || selectedRow.tipo === 4
          ? false
          : selectedRow.tipo === 2 || selectedRow.tipo === 3
            ? !selectedRow.origen || !selectedRow.lote || !selectedRow.cupon
            : selectedRow.tipo === 10
              ? !selectedRow.cupon || !selectedRow.origen || !selectedRow.barcode
              : selectedRow.tipo === 6 || selectedRow.tipo === 7
                ? !selectedRow.origen || !selectedRow.cupon
                : selectedRow.tipo === 8
                  ? !selectedRow.moneda || !selectedRow.cupon
                  : selectedRow.tipo === 51
                    ? !selectedRow.retencion
                    : true)
    : true

  return (
    <>
      <ContentWithOutSubTabs value={tab} setValue={setTab} children={renderTabs(tab)} />

      {add.suspense && (
        <AddItem
          data={dataBefore?.data}
          open={openAdd}
          handleClose={closeAdd}
          render={render}
          setRender={setRender}
          dataInfo={data}
          setRows={setFormEdit}
          setData={setData}
        />
      )}

      <DialogComponent
        open={paymentDetail.open}
        title="Editar medio de pago"
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        handleclose={setClosePaymentDetail}
        widthLarge="500px"
        children={
          selectedRow ? (
            <InputsWithoutValidate
              fields={editFields(selectedRow, handleChangeItem, dataBefore.data)}
              spacing={2}
            />
          ) : null
        }
        actions={
          <CancelConfirmButtons
            disabledSubmit={isLoading || isSubmitDisabled}
            disabledCancel={isLoading}
            isLoading={isLoading}
            onClickSubmit={editItem}
            onClickCancel={setClosePaymentDetail}
          />
        }
      />
    </>
  )
}

export default PaymentMethods
